import { getElements } from "../utilities/elements.js";

/**
 * Mixin for custom elements that adopts stylesheets from the document into the
 * shadowRoot to work around shadow DOM style encapsulation.
 */
const WithoutStyleEncapsulation = (superclass) => {
  // Get stylesheet link tags in head
  const links = getElements(document.head, "link[rel='stylesheet']");
  // Load stylesheets from head and map them to CSSStyleSheet objects
  const fetchedStyleSheets = links.map(
    /** @param {HTMLLinkElement} link */ (link) => {
      return fetch(link.href)
        .then((response) => response.text())
        .then((css) => {
          const styleSheet = new CSSStyleSheet();
          styleSheet.replaceSync(css);
          return styleSheet;
        });
    },
  );

  return class extends superclass {
    constructor() {
      super();
      this.#adoptDocumentStyleSheets();
    }

    /**
     * The shadow DOM has encapsulated styles, which makes sense for standalone
     * components that will be embedded in different websites. For components
     * that are all used in the same website, it can be easier to share a
     * single stylesheet.
     *
     * In the future we could generate a separate stylesheet for each component
     * but it's too much work to set up right now.
     */
    async #adoptDocumentStyleSheets() {
      // Hide the element until stylesheets are adopted
      // this.style.display = "none";
      const styleSheets = await Promise.all(fetchedStyleSheets);
      for (const styleSheet of styleSheets) {
        this.shadowRoot.adoptedStyleSheets.push(styleSheet);
      }
      // Show element after stylesheets are adopted
      // this.style.display = null;
    }
  };
};

export { WithoutStyleEncapsulation };
